import React from "react";
import Checkbox from "@mui/material/Checkbox";

import { useOnEscEffect, useOnReFocuse } from "src/utils/keyEffects";

const CheckboxField = ({
  field,
  onSubmit,
  setValue,
  value,
  innerRef,
  onRevert,
  setEdit,
  rowIndex,
  columnIndex,
  nextRow,
  prevRow,
  nextColumn,
  prevColumn,
  onChange,
  onClose,
  ...props
}) => {
  const handleSubmit = value => {
    onSubmit(value);
    nextRow();
  };

  useOnReFocuse(innerRef, onSubmit);
  useOnEscEffect(innerRef, onRevert);

  return (
    <Checkbox
      sx={{ width: "initial" }}
      open={true}
      ref={innerRef}
      data-id={field.id}
      labelId={field.id}
      id={field.id}
      value={Boolean(value)}
      {...props}
      onChange={event => handleSubmit(Boolean(event.target.value))}
    />
  );
};

export default CheckboxField;
